import script from "./OptionsField.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsField.vue?vue&type=script&setup=true&lang=js"

import "./OptionsField.vue?vue&type=style&index=0&id=66c47410&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c47410"]])

export default __exports__